import {DOM} from '../helpers/DOM.js'
export class MyAccountStats {
	#donorsData = {};
	#campaignData = {};
	#chartData = {};
	#totalsList = {};
	#dasboardAdditionalData = {};
	#chartDataAlreadyFetched = false;
	#activeTimeline = '1y';

	#fetching = {};
	#loaderFallbackTimer = null;
	#pendingDatatableIds = new Set();

	constructor() {
		this.#fetchData();
		this.#addEvents();
		this.#setupLoaderFallback();
	}

	async #fetchData() {
		this.#fetchStatsChart();
		this.#fetchDonations2();
		this.#datatable();
		this.#fetchDonorsData();
		this.#fetchCampaignData();
		this.#listenToDatatables();
	}

	async #fetchStatsChart() {
		if (this.#fetching?.chart) return;
		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */);

		const statsChartWrapper = DOM.el('.gamification-my-campaign-page')
			? DOM.el('.levcharity-dashboard-container .custom_bar_chart_wrapper')
			: DOM.el('.custom_bar_chart_wrapper');
		if (!statsChartWrapper) {
			this.#adjustmentLoading(true);
			return;
		}

		this.#fetching.chart = true;
		// Show loading state before making the request
		this.#adjustmentLoading(false);

		try {
			const response = await Helper.request(admin_ajax[0], {
				action: statsChartWrapper.dataset.action,
				token: statsChartWrapper.dataset.token,
				timeline: this.#activeTimeline,
			});


			if ( response.success ) {
				this.#chartData = {
					totalToday: response.total_today,
					teamMembers: response.team_members,
					goal: response.goal,
					totalRaised: response.total_raised,
					totalDonors: response.total_donors,
					data: response.chart_data,
				}

				// Wait for all animations to complete before hiding the loader
				await this.#renderChart();
				this.#chartDataAlreadyFetched = true;
				this.#adjustmentLoading(true);

			}
		} catch ( error ) {
			console.error('Error fetching chart data:', error);
		} finally {
			this.#fetching.chart = false;
			// Hide the loader after all animations are complete
		}
	}




	async #fetchDonations2() {
		if (this.#fetching?.donations) return;
		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */);

		const dashboardAdditionalDataWrapper = DOM.el('.levcharity-myacccount-dashboard-additional-data');
		if (!dashboardAdditionalDataWrapper) {
			this.#fetching.totals = false;
			return;
		}

		const {action, token} = dashboardAdditionalDataWrapper.dataset || {};
		if (!action || !token) {
			this.#fetching.totals = false;
			return;
		}


		this.#fetching.totals = true;
		Helper.request(admin_ajax[0], {
			action,
			token,
		})
			.then((response) => {
				if (response.success) {
					this.#dasboardAdditionalData = {
						totalDonors: response.total_donors,
						totalDonations: response?.total_donations || [],
						growthPercent: response?.growthPercent || [],
						topDonors: response?.top_donors || [],
						topCampaigns: response?.top_campaigns || [],
					}
				}

				this.#renderTotals2();
				this.#fetching.totals = false;
			})
			.catch((error) => {
				console.error(error)
				this.#fetching.totals = false;
			})

	}

	async #addEvents() {
		const {gsap} = await import('gsap')

		let timeout = null;

		DOM.addEvent('mouseover', '.custom_bar_chart_wrapper .chart_bar:not(.empty)', (event, bar) => {
			if (!window.matchMedia("(pointer: coarse)").matches) {
				clearTimeout(timeout);
				timeout = null;
				this.#activateChartBar(bar);
			}
		});
		DOM.addEvent('mouseout', '.custom_bar_chart_wrapper .chart_bar:not(.empty)', (event, bar) => {
			if (!window.matchMedia("(pointer: coarse)").matches) {
				timeout = setTimeout(() => {
					this.#deactivateChartBar(bar);
				}, 300);
			}
		});

		DOM.addEvent('click', '.custom_bar_chart_wrapper .chart_bar:not(.empty)', (event, bar) => {
			const active = DOM.el('.custom_bar_chart_wrapper .chart_bar.active')
			if (active) {
				const vars = this.#deactivateChartBar(active, timeout, interval);
				interval = vars.interval
				timeout = vars.timeout
			}
			const vars = this.#activateChartBar(bar, timeout, interval);
			interval = vars.interval
			timeout = vars.timeout
		})

		DOM.addEvent('click', document, (event, bar) => {
			if (!DOM.compareElement(event.target, '.custom_bar_chart_wrapper .chart_bar:not(.empty)')) {
				const active = DOM.el('.custom_bar_chart_wrapper .chart_bar.active')
				if (active) {
					const vars = this.#deactivateChartBar(active, timeout, interval);
					interval = vars.interval
					timeout = vars.timeout
				}
			}
		})

		DOM.addEvent('click', '.custom_bar_chart_wrapper .period_buttons button', (event, button) => {
			if (button.closest('.gamification-my-campaign-page')) {
				return;
			}
			event.preventDefault();
			if (this.#fetching?.chart) return;
			this.#activeTimeline = button.dataset.period;
			const currentActive = DOM.el('.custom_bar_chart_wrapper .period_buttons button.active')
			currentActive.classList.remove('active')
			button.classList.add('active');

			this.#fetchStatsChart();
		})
		DOM.addEvent('click', '.accounts_bar .buttons_group button', (event, button) => {
			const current = DOM.el('.accounts_bar .buttons_group button.active');

			current.classList.remove('active');
			button.classList.add('active');

			const recent = DOM.el('.accounts_bar .recent_donations')
			const tops = DOM.el('.accounts_bar .tops')
			const topPrizes = DOM.el('.accounts_bar .top_prizes')

			if (button.classList.contains('recent_btn')) {
				recent.style.display = '';
				tops.style.display = 'none';

				if (topPrizes) {
					topPrizes.style.display = 'none';
				}
			} else if (button.classList.contains('top_prizes_btn')) {
				recent.style.display = 'none';
				tops.style.display = 'none';
				topPrizes.style.display = '';
			} else {
				recent.style.display = 'none';
				tops.style.display = '';

				if (topPrizes) {
					topPrizes.style.display = 'none';
				}
			}
		})

		DOM.addEvent('click', '.html_chart_wrapper .arrow-left', (event) => {
			const scrollChartBar = DOM.el('.html_chart');
			scrollChartBar.scrollBy({ left: -150, behavior: "smooth" })
		});

		DOM.addEvent('click', '.html_chart_wrapper .arrow-right', (event) => {
			const scrollChartBar = DOM.el('.html_chart');
			scrollChartBar.scrollBy({ left: 150, behavior: "smooth" })
		});



	}

	async #activateChartBar(bar, timeout, interval) {
		const {gsap} = await import('gsap')
		clearTimeout(timeout)
		const placeholder = DOM.el('.custom_bar_chart_wrapper .placeholder')
		placeholder.textContent = bar.dataset.value

		if (timeout) clearTimeout(timeout);
		if (interval) clearInterval(interval);

		bar.classList.add('active')

		const span = DOM.el('.chart_bar_inner span', bar);

		const animate = () => {
			let top = span.offsetTop - placeholder.offsetHeight - 8;
			let left = bar.offsetLeft;

			if (placeholder.offsetWidth > bar.offsetWidth) {
				left -= (placeholder.offsetWidth - bar.offsetWidth) / 2
			} else {
				left += (bar.offsetWidth - placeholder.offsetWidth) / 2
			}

			gsap.to(placeholder, {
				top: top,
				left: left,
				autoAlpha: 1,
				duration: .2
			})
		}

		interval = setInterval(() => {
			animate();
		}, 50)

		timeout = setTimeout(() => {
			clearInterval(interval);
		}, 100);

		return {interval, timeout}
	}

	async #deactivateChartBar(bar, timeout, interval) {
		const {gsap} = await import('gsap')
		clearInterval(interval)
		bar.classList.remove('active')
		timeout = setTimeout(() => {
			const placeholder = DOM.el('.custom_bar_chart_wrapper .placeholder')
			gsap.to(placeholder, {
				autoAlpha: 0,
				duration: .2,
			})
		}, 300)
		return {interval, timeout}
	}

	async #renderChart() {
		const wrapper = DOM.el('.levcharity_my_account_content');
		const statsChartWrapper = DOM.el('.custom_bar_chart_wrapper', wrapper);
		const currencySymbol = statsChartWrapper.dataset.currencySymbol;
		const progressbar = DOM.el('.progress-bar-wrapper', wrapper);
		const totalsToday = DOM.el('.totals_total', wrapper);
		const raised = DOM.els('.total_raised', wrapper);
		const goal = DOM.el('.goal', wrapper);
		const totalDonors = DOM.el('.total_donors', wrapper);
		const teamMembers = DOM.el('.team_members', wrapper);
		const htmlChart = DOM.el('.html_chart', wrapper);

		let chartMax = 0;
		let fillingBarsCount = 0;
		this.#chartData.data.forEach((bar) => {
			if (bar.value > chartMax) {
				chartMax = bar.value;
			}
		});

		const bars = [];

		htmlChart.innerHTML = '';

		if (this.#chartData.data.length) {
			htmlChart.append(...this.#chartData.data.map((bar) => {
				const value = bar.value ? (bar.value / (chartMax / 100)) : 0;

				const barElement = DOM.create('div', {
					className: ['chart_bar', (!bar.value ? 'empty' : '')],
					dataValue: currencySymbol + bar.value.toFixed(2)
				}, [
					DOM.create('div', {className: 'chart_bar_inner'}, [
						DOM.create('span')
					]),
					DOM.create('div', {className: 'chart_bar_label', dataLevTooltip: bar.label_description}, bar.label)
				]);

				if (bar.value) {
					bars.push({
						barElement,
						value
					});
				}

				return barElement;
			}), DOM.create('span', {className: 'placeholder'}));
		} else {
			htmlChart.append(DOM.create('p', {className: 'no-data'}, wp.i18n.__('Start Fundraising to see statistics here', 'levcharity')));
		}

		bars.forEach((item, index) => {
			setTimeout(() => {
				DOM.el('.chart_bar_inner span', item.barElement).style.height = item.value + '%';
			}, 50 * (index + 1));
		});

		if (!this.#chartDataAlreadyFetched) {
			const animationPromises = [];

			// Add all animation promises to the array
			if (totalsToday) animationPromises.push(this.#numberAnimation(this.#chartData.totalToday, totalsToday, currencySymbol));

			if (raised.length) {
				[...raised].forEach(e => {
					animationPromises.push(this.#numberAnimation(this.#chartData.totalRaised, e, currencySymbol));
				});
			}

			if (goal) animationPromises.push(this.#numberAnimation(this.#chartData.goal, goal, currencySymbol));
			if (totalDonors) animationPromises.push(this.#numberAnimation(this.#chartData.totalDonors, totalDonors, '', '', 0, false));
			if (teamMembers) animationPromises.push(this.#numberAnimation(this.#chartData.teamMembers, teamMembers, '', '', 0, false));

			const percentage = Math.min(100, this.#chartData.totalRaised / (+this.#chartData.goal / 100));
			if (progressbar) {
				progressbar.style.setProperty('--progress', percentage);
			}

			if (progressbar) {
				animationPromises.push(
					this.#numberAnimation(
						percentage,
						DOM.el('.circular-progress-percentage', progressbar),
						'',
						'%',
						percentage === 100 ? null : 0,
						percentage === 100
					)
				);
			}

			// Return a promise that resolves when all animations are complete
			return Promise.all(animationPromises);
		}

		return Promise.resolve();

	}

	#renderTotals() {
		const accountsBarWrapper = DOM.el('.accounts_bar');
		if (!accountsBarWrapper) {
			return;
		}

		const currencySymbol = accountsBarWrapper.dataset?.currencySymbol || '';

		const recentDonations = DOM.el('.recent_donations', accountsBarWrapper);
		const tops = DOM.el('.tops', accountsBarWrapper);
		const topPrizes = DOM.el('.top_prizes', accountsBarWrapper);
		const {
			recentDonations: recentDonationsList = [],
			participants: participantsList = [],
			topDonations: topDonationsList = [],
			topPrizes: topPrizesList = []
		} = this.#totalsList || {};


		const userSVG = `<svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M42.672 42.672C41.2482 44.1066 39.6941 45.3239 38.0421 46.3238C30.0647 51.2254 19.9353 51.2254 11.9579 46.3238C10.3059 45.3239 8.75177 44.1066 7.32801 42.672C-2.44267 32.9122 -2.44267 17.0878 7.32801 7.32801C17.0878 -2.44267 32.9122 -2.44267 42.672 7.32801C52.4427 17.0878 52.4427 32.9122 42.672 42.672Z" fill="#00ADEF"/>
            <path d="M25.0009 28.2604C29.8028 28.2604 33.6956 24.3676 33.6956 19.5657C33.6956 14.7637 29.8028 10.871 25.0009 10.871C20.1989 10.871 16.3062 14.7637 16.3062 19.5657C16.3062 24.3676 20.1989 28.2604 25.0009 28.2604Z" fill="#0076A3"/>
            <path d="M38.0434 41.3026V46.3238C30.066 51.2254 19.9366 51.2254 11.9592 46.3238V41.3026C11.9592 34.0968 17.7956 28.2605 25.0013 28.2605C32.207 28.2605 38.0434 34.0968 38.0434 41.3026Z" fill="#0076A3"/>
            <path opacity="0.3" d="M25.0009 5.43688C27.8017 5.43688 30.0808 3.30993 30.3764 0.588491C28.644 0.209184 26.8475 0.00268555 25.0009 0.00268555C11.1948 0.00268555 0.00366211 11.1939 0.00366211 25C0.00366211 26.8465 0.210161 28.643 0.589468 30.3755C3.312 30.0798 5.43785 27.8008 5.43785 25C5.43785 14.2131 14.2141 5.43688 25.0009 5.43688Z" fill="white"/>
            <path opacity="0.15" d="M49.4122 19.6243C46.6897 19.9199 44.5638 22.199 44.5638 24.9998C44.5638 35.7866 35.7876 44.5629 25.0007 44.5629C22.2 44.5629 19.9209 46.6898 19.6252 49.4112C21.3577 49.7906 23.1542 49.9971 25.0007 49.9971C38.8069 49.9971 49.998 38.8059 49.998 24.9998C49.998 23.1532 49.7915 21.3567 49.4122 19.6243Z" fill="black"/>
            <path d="M6.57298 17.3127C6.3241 17.3127 6.07304 17.2551 5.83611 17.1355C5.03293 16.728 4.7134 15.7466 5.12097 14.9434C7.31529 10.621 10.9236 7.07358 15.2796 4.95316C16.0872 4.55864 17.0642 4.89556 17.4588 5.70525C17.8533 6.51494 17.5164 7.49093 16.7067 7.88436C12.9853 9.69612 9.90306 12.7273 8.02826 16.4193C7.74025 16.9866 7.16748 17.3127 6.57298 17.3127Z" fill="white"/>
        </svg>`;
		const renderCard = (title, date, metadata = '', number = true, image = true) => {
			const card = DOM.create('div', {className: 'account_block'})
			card.innerHTML = image ? userSVG : '';

			const dateElement = date && DOM.create('span', {className: 'date'}, date);
			const numberElement = number && DOM.create('span', {className: 'number'}, currencySymbol + 0.00);
			const seperatedPoint = DOM.create('span', {className: 'seperator'}, '•')
			const metadataElement = DOM.create('span', {})
			metadataElement.innerHTML = metadata
			const account_block_texts = DOM.create('div', {className: 'account_block_texts'}, [
				DOM.create('div', {}, title),
				DOM.create('p', {}, [
					...(number ? [numberElement] : []),
					...(number && date ? [seperatedPoint] : []) ,
					...(date ? [dateElement] : [])
				]),
				metadata ? metadataElement : null
			])

			card.append(account_block_texts)

			return {
				numberElement,
				card
			}
		}

		if (recentDonations) {
			recentDonations.innerHTML = '';
		}
		if (tops) {
			tops.innerHTML = '';
		}
		if (topPrizes) {
			topPrizes.innerHTML = '';
		}

		if(recentDonations && recentDonationsList.length) {
			recentDonations.append(...recentDonationsList.map((donation) => {
				const {
					numberElement,
					card
				} = renderCard(donation.first_name + ' ' + donation.last_name, donation.order_date, donation.metadata_html);

				const initialInnerHTML = numberElement.innerHTML
				numberElement.innerHTML = donation.currency;
				const currency = numberElement.innerHTML
				numberElement.innerHTML = initialInnerHTML;


				setTimeout(() => {
					this.#numberAnimation(donation.total, numberElement, currency)
				});

				return card;
			}))
		} else {
			recentDonations?.append(DOM.create('p', {className: 'no-data'}, wp.i18n.__('Start Fundraising to see statistics here', 'levcharity')))
		}

		if(tops && participantsList.length) {
			tops.append(...participantsList.map((participant) => {
				const {numberElement, card} = renderCard(participant.name, '', participant.created_at);

				setTimeout(() => {
					this.#numberAnimation(participant.total_amount, numberElement, currencySymbol)
				});

				return card;
			}))
		} else if(topDonationsList.length) {
			tops?.append(...topDonationsList.map((donation) => {
				const {numberElement, card} = renderCard(donation.first_name + ' ' + donation.last_name, donation.order_date, donation.metadata_html);

				const initialInnerHTML = numberElement.innerHTML
				numberElement.innerHTML = donation.currency;
				const currency = numberElement.innerHTML
				numberElement.innerHTML = initialInnerHTML;


				setTimeout(() => {
					this.#numberAnimation(donation.total, numberElement, currency)
				});

				return card;
			}))
		} else {
			tops?.append(DOM.create('p', {className: 'no-data'}, wp.i18n.__('Start Fundraising to see statistics here', 'levcharity')))
		}

		if (topPrizes && topPrizesList.length) {
			topPrizes.append(...topPrizesList.map((prize) => {
				const {numberElement, card} = renderCard(prize.name, '', prize.metadata_html, false, false);

				return card;
			}))
		}
	}

	#numberAnimation(to, el, prefix, suffix = '', from = 0, withFractions = true) {
		return new Promise((resolve) => {
			if (!el) {
				resolve();
				return;
			}

			import('gsap').then(({ gsap }) => {
				const tweenObj = { value: Number(from) || 0 };
				const targetValue = Number(to) || 0;

				gsap.to(tweenObj, {
					value: targetValue,
					duration: 0.25,
					ease: 'power2.inOut',
					onUpdate: () => {
						const v = Number(tweenObj.value) || 0;
						el.textContent = `${prefix}${v.toFixed(withFractions ? 2 : 0)}${suffix}`;
					},
					onComplete: resolve
				});
			}).catch(error => {
				console.error('Error loading GSAP:', error);
				resolve();
			});
		});
	}

	async #datatable() {
		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */);

		const leaderboardsContainer = DOM.el('.leaderboards-container');
		const datatableRegistry = window.LevDataTables?.datatableInstances;
		if (!leaderboardsContainer || !datatableRegistry) {
			return;
		}

		const {id: _id} = leaderboardsContainer.dataset || {};
		if (!_id) {
			return;
		}

		let userRank = 0;

		Object.keys(datatableRegistry).forEach((id) => {
			const DataTable = datatableRegistry[id];

			DataTable.on('draw.dt', () => {
				const json = DataTable.context[0]?.json;
				const absoluteRank = Number(json?.userRank);

				if (Number.isFinite(absoluteRank) && absoluteRank > 0) {
					userRank = absoluteRank;
				} else if (json?.userRank === 0 || json?.userRank === '0') {
					userRank = 0;
				} else {
					// Backwards compatible when the endpoint does not return userRank.
					const pageIndex = (json?.data || []).findIndex((row) => _id === row.id);
					userRank = pageIndex >= 0 ? pageIndex + 1 : 0;
				}

				const positionElement = DOM.el('.position', leaderboardsContainer);
				if (!positionElement) {
					return;
				}

				positionElement.textContent = userRank > 0
					? Helper.ordinalNumberFormatter(userRank)
					: '—';
			});
		});

		DOM.addEvent('click', '#gotoposition', (event, button) => {
			event.preventDefault();

			if (userRank <= 0) {
				return;
			}

			Object.keys(datatableRegistry).forEach((id) => {
				const DataTable = datatableRegistry[id];

				const pageSize = DataTable.page.len();
				const pageNum = Math.floor((userRank - 1) / pageSize);

				// Chaiathon can wait immediately after draw() because its table is
				// client-side. UH uses server-side pagination, so wait until the
				// requested AJAX page has drawn before starting that delay.
				DataTable.one('draw', () => {
					window.setTimeout(() => {
						const rowIndex = (userRank - 1) % pageSize;
						const rowNode = DataTable.row(rowIndex).node();

						if (!rowNode) {
							return;
						}

						// scrollIntoView() scrolls every scrollable ancestor, which shifts the
						// panels around the table instead of the page. Move the one scroller
						// the row actually sits in: my-account layouts built as a fixed height
						// app shell keep the document unscrollable and scroll an inner panel,
						// so scrolling the window there does nothing at all.
						this.#scrollRowIntoView(rowNode);

						rowNode.classList.add('highlight');
						window.setTimeout(() => rowNode.classList.remove('highlight'), 2000);
					}, 300);
				});
				DataTable.page(pageNum).draw('page');
			});
		});
	}

	/**
	 * Centre a leaderboard row in whichever element scrolls it: the closest
	 * scrollable ancestor when the layout scrolls an inner panel, otherwise the
	 * window. Only that one element is moved, so the panels around the table stay
	 * where they are.
	 *
	 * @param {HTMLElement} rowNode - The row to bring into view.
	 */
	#scrollRowIntoView(rowNode) {
		const rect = rowNode.getBoundingClientRect();
		const scroller = this.#scrollableAncestor(rowNode);

		if (scroller) {
			const scrollerRect = scroller.getBoundingClientRect();
			const centered = (scroller.clientHeight - rect.height) / 2;
			const targetTop = scroller.scrollTop + (rect.top - scrollerRect.top) - centered;
			const maxScroll = Math.max(0, scroller.scrollHeight - scroller.clientHeight);

			scroller.scrollTo({
				top: Math.max(0, Math.min(targetTop, maxScroll)),
				behavior: 'smooth',
			});

			return;
		}

		const rowCenterY = rect.top + window.scrollY + rect.height / 2;
		const targetTop = rowCenterY - window.innerHeight / 2;
		const maxScroll = Math.max(
			0,
			document.documentElement.scrollHeight - window.innerHeight
		);

		window.scrollTo({
			top: Math.max(0, Math.min(targetTop, maxScroll)),
			left: 0,
			behavior: 'smooth',
		});
	}

	/**
	 * Closest ancestor that both allows vertical scrolling and has something to
	 * scroll. Wrappers that only overflow horizontally report overflow-y as auto
	 * as well, so the scrollable height is what decides.
	 *
	 * @param {HTMLElement} element - The element to walk up from.
	 * @return {HTMLElement|null} The scrolling ancestor, or null when the document scrolls.
	 */
	#scrollableAncestor(element) {
		for (let parent = element.parentElement; parent; parent = parent.parentElement) {
			if (parent === document.body || parent === document.documentElement) {
				return null;
			}

			const {overflowY} = window.getComputedStyle(parent);
			const scrolls = overflowY === 'auto' || overflowY === 'scroll';

			if (scrolls && parent.scrollHeight - parent.clientHeight > 1) {
				return parent;
			}
		}

		return null;
	}


	#renderTotals2(){
		const statsChartWrapper = DOM.el('.levcharity-dashboard-container .custom_bar_chart_wrapper')
			|| DOM.el('.custom_bar_chart_wrapper');
		const dashbaordAdditionalDataWrapper = DOM.el('.levcharity-myacccount-dashboard-additional-data');
		if (!dashbaordAdditionalDataWrapper) {
			return;
		}

		const currencySymbol = statsChartWrapper?.dataset?.currencySymbol || '';
		const totalsWrapper = DOM.el('.levcharity-myaccount-dashboard-totals');
		const totalDonors = this.#dasboardAdditionalData?.totalDonors || 0;
		const totalDonations = this.#dasboardAdditionalData?.totalDonations || 0;
		const growthPercent = this.#dasboardAdditionalData?.growthPercent || 0;
		if(totalsWrapper){
			if(totalDonors){
				const totalDonorsWrapper = DOM.el('.levcharity-myaccount-total-donors-wrapper', totalsWrapper);
				if(totalDonorsWrapper){
					const totalDonorsValue = DOM.el('.total-donors-value', totalDonorsWrapper);
					this.#numberAnimation(totalDonors, totalDonorsValue, '', '', 0, false);
				}
			}
			if(totalDonations){
				const totalDonationsWrapper = DOM.el('.levcharity-myaccount-total-donation-wrapper', totalsWrapper);
				if(totalDonationsWrapper){
					const totalDonationsValue = DOM.el('.total-donations-value', totalDonationsWrapper);
					this.#numberAnimation(totalDonations, totalDonationsValue, currencySymbol, '', 0, true);
				}
			}
			if(growthPercent){
				const totalDonationsWrapper = DOM.el('.levcharity-myaccount-total-donation-wrapper', totalsWrapper);
				if(totalDonationsWrapper){
					const totalDonationsGrowthPercent = DOM.el('.total-growth-percent', totalDonationsWrapper);
					this.#numberAnimation(growthPercent, totalDonationsGrowthPercent, '', '%', 0, false);
				}

			}
		}


		const renderTops = (title, subtitle, total, currencySymbol) => {
			const card = DOM.create('div', {className: `top-row-container`})
			const titleElement = DOM.create('span', {className: `top-row-title`}, title);
			const subtitleElement = DOM.create('span', {className: `top-row-subtitle`}, subtitle);
			const leftSide = DOM.create('div', {className: `top-row-left-side`}, [titleElement, subtitleElement])
			const numberElement = DOM.create('span', {className: `top-row-number`}, currencySymbol + parseFloat(total || 0).toFixed(2));
			const rightSide = DOM.create('div', {className: `top-row-right-side`}, [numberElement])
			const topCard = DOM.create('div', {className: `top-row-wrapper`}, [leftSide, rightSide])

			card.append(topCard)

			return {
				numberElement,
				card
			}

		}

		const topDonors = this.#dasboardAdditionalData?.topDonors || [];
		const topCampaigns = this.#dasboardAdditionalData?.topCampaigns || [];
		if(topDonors.length > 0 && dashbaordAdditionalDataWrapper){
			const topDonorsWrapper = DOM.el('.levcharity-myaccount-top-donors-wrapper')
			if(topDonorsWrapper){
				const dataContainer = DOM.el('.data-container', topDonorsWrapper);
				if (!dataContainer) {
					return;
				}
				dataContainer.innerHTML = '';
				dataContainer.append(...topDonors.map((donor) => {
					const {numberElement, card} = renderTops(donor.first_name + donor.last_name, `Last: ${donor.last_donation_date}`, donor.total, donor.currency);

					setTimeout(() => {
						this.#numberAnimation(donor.total, numberElement, donor.currency)
					});


					return card;
				}));

			}
		}

		if(topCampaigns.length > 0 && dashbaordAdditionalDataWrapper){
			const topCampaignsWrapper = DOM.el('.levcharity-myaccount-top-campaigns-wrapper')
			if(topCampaignsWrapper){
				const dataContainer = DOM.el('.data-container', topCampaignsWrapper);
				if (!dataContainer) {
					return;
				}
				dataContainer.innerHTML = '';
				dataContainer.append(...topCampaigns.map((campaign) => {
					const {numberElement, card} = renderTops(campaign?.edit_title || campaign?.campaign_name, `${campaign.donors} Donors`, campaign.total_raised, campaign?.currency || '');
					setTimeout(() => {
						this.#numberAnimation(campaign.total_raised, numberElement, campaign?.currency || '')
					});
					return card;
				}));
			}
		}








	}

	async #fetchDonorsData(){
		if (this.#fetching?.donorsDashboard) return;
		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */);

		const donorsDashboard = DOM.el('.donor-dashboard');
		if (!donorsDashboard) {
			this.#fetching.donorsDashboard = false;
			return;
		}

		const {action, token} = donorsDashboard.dataset || {};
		if (!action || !token) {
			this.#fetching.donorsDashboard = false;
			return;
		}

		this.#fetching.donorsDashboard = true;
		Helper.request(admin_ajax[0], {
			action,
			token,
			timeline: this.#activeTimeline
		})
			.then((response) => {
				if (response.success) {
					this.#donorsData = {
						totalDonors: response.total_donors,
						majorGivers: response.major_givers,
						regularGivers: response.regular_givers,
						totalDonations: response.total_donations,
					}
				}
				this.#renderDonorsDashboard();
				this.#fetching.donorsDashboard = false;
			})
			.catch((error) => {
				console.error(error)
				this.#fetching.donorsDashboard = false;
			})

	}

	#renderDonorsDashboard(){

		const getItemCount = (itemName) => {
			const itemCount = DOM.el(`.item-count`, itemName);
			return itemCount;
		}


		const donorsDashboard = DOM.el('.donor-dashboard');
		const donorsContainer = DOM.el('.levcharity-myaccount-donors-container');
		if(donorsDashboard && donorsContainer){
			const donorsItem = DOM.el('.donors', donorsDashboard)
			const majorsItem = DOM.el('.majors', donorsDashboard);
			const regularsItem = DOM.el('.regulars', donorsDashboard);
			const totalsItem = DOM.el('.total', donorsDashboard);
			const currencySymbol = donorsContainer.dataset?.currencySymbol || '';


			if(donorsItem && this.#donorsData.totalDonors){

			}

			if (donorsItem && this.#donorsData.totalDonors != null) {
				const item_count = getItemCount(donorsItem);
				this.#numberAnimation(this.#donorsData.totalDonors, item_count,  '', '', 0, false);
			}
			if (majorsItem && this.#donorsData.majorGivers != null) {
				const item_count = getItemCount(majorsItem);
				this.#numberAnimation(this.#donorsData.majorGivers, item_count,  '', '', 0, false);
			}
			if (regularsItem && this.#donorsData.regularGivers != null) {
				const item_count = getItemCount(regularsItem);
				this.#numberAnimation(this.#donorsData.regularGivers, item_count,  '', '', 0, false);
			}
			if (totalsItem && this.#donorsData.totalDonations != null) {
				const item_count = getItemCount(totalsItem);
				this.#numberAnimation(this.#donorsData.totalDonations, item_count,  currencySymbol, '', 0, false);
			}
		}



	}


	async #fetchCampaignData(){
		const {Helper} = await import('../helpers/Helper.js' /* webpackChunkName: "helper" */);
		const campaignDashboard = DOM.el('.levcharity-myaccount-campaign-dashboard')
		if(campaignDashboard){
			this.#fetching.campaignData = true;
			Helper.request(admin_ajax[0], {
				action: campaignDashboard.dataset.action,
				token: campaignDashboard.dataset.token,
				metaId: campaignDashboard.dataset.metaId,
				isTeam: campaignDashboard.dataset.isTeam,
				p2pCampaignId: campaignDashboard.dataset.p2pCampaignId ?? '',
			})
				.then((response) => {
					if (response.success) {
						this.#campaignData = {
							goal: response.goal,
							totalRaised: response.total_raised,
							raisedPercentage: response.raised_percentage,
							items: response?.items || [],
						}
					}
					this.#renderCampaignData();
					this.#fetching.campaignData = false;
				})
				.catch((error) => {
					console.error(error)
					this.#fetching.campaignData = false;
				})
		}
	}


	async #renderCampaignData(){
		const campaignDashboard = DOM.el('.levcharity-myaccount-campaign-dashboard');
		if (!campaignDashboard) {
			return;
		}
		const currency = campaignDashboard.dataset?.currency || '';
		const progressWrapper = DOM.el('.progress--wrapper', campaignDashboard);
		const infoBlockContainers = DOM.el('.info-blocks-container', campaignDashboard);

		if(progressWrapper){
			const progressTitle = DOM.el('.progress--title', progressWrapper);
			const campaignItemProgress = DOM.el('.campaign-item-progress', progressWrapper);
			const goalInfo = DOM.el('.goal-info', progressWrapper);
			if(progressTitle){
				this.#numberAnimation(Math.round(this.#campaignData.raisedPercentage), DOM.el('.percentage', progressTitle), '', '%', 0, false)
			}
			if(goalInfo){
				this.#numberAnimation(this.#campaignData.totalRaised, DOM.el('.raised', goalInfo), currency)
				this.#numberAnimation(this.#campaignData.goal, DOM.el('.goal', goalInfo), currency)
			}
			if(campaignItemProgress){
				const progressFill = DOM.el('.campaign-item-progress-filled', campaignItemProgress);
				if (progressFill) {
					progressFill.style.width = `${Math.min(this.#campaignData.raisedPercentage)}%`;
				}
			}

		}
		if (infoBlockContainers && this.#campaignData.items.length > 0) {
			this.#campaignData.items.forEach((item, index) => {
				const itemBlock = document.querySelector(`.info-block.item-${index}`);
				console.log(DOM.el('.info-data', itemBlock));
				if(item.prefix === 'currency') item.prefix = currency
				this.#numberAnimation(
					item.value,
					DOM.el('.info-data', itemBlock),
					item.prefix,
					item.suffix,
					false,
					item?.fractions
				);
			});
		}

	}


	async #adjustmentLoading(stopLoading = true) {
		const overlay = document.querySelector('.levcharity-loader');
		if (!overlay) return;

		if (stopLoading) {
			overlay.classList.remove('active');
		} else {
			overlay.classList.add('active');
		}
	}



	#hasActiveOperations() {
		return Object.values(this.#fetching).some((value) => Boolean(value));
	}

	#setupLoaderFallback() {
		const checkWhenIdle = () => {
			if (!this.#hasActiveOperations()) {
				this.#adjustmentLoading(true);
				this.#loaderFallbackTimer = null;
				return;
			}

			this.#loaderFallbackTimer = window.setTimeout(checkWhenIdle, 300);
		};

		const onReady = () => {
			if (this.#loaderFallbackTimer !== null) {
				window.clearTimeout(this.#loaderFallbackTimer);
				this.#loaderFallbackTimer = null;
			}

			checkWhenIdle();
		};

		if (document.readyState === 'complete') {
			onReady();
		} else {
			window.addEventListener('load', onReady, {once: true});
		}
	}

	async #listenToDatatables() {
		const datatableRegistry = window.LevDataTables?.datatableInstances;

		if (!datatableRegistry) {
			this.#fetching.datatables = false;
			return;
		}

		const identifiers = Object.keys(datatableRegistry);

		if (!identifiers.length) {
			this.#fetching.datatables = false;
			return;
		}

		this.#pendingDatatableIds.clear();
		identifiers.forEach((identifier) => this.#pendingDatatableIds.add(identifier));

		if (this.#pendingDatatableIds.size) {
			this.#fetching.datatables = true;
		}

		identifiers.forEach((identifier) => {
			const DataTable = datatableRegistry[identifier];
			DataTable.on('xhr.dt', (e, settings, json, xhr) => {
				this.#pendingDatatableIds.delete(identifier);

				if (this.#pendingDatatableIds.size === 0) {
					this.#fetching.datatables = false;
				}

				this.#adjustmentLoading();
			});
		});
	}


}
